import api from './api'

export const therapyBundleService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/bundles?${query.toString()}`)
  },
  fetchDetail(id) {
    return api.get(`/therapy/bundles/${id}`)
  },
  create(payload) {
    return api.post('/therapy/bundles', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/bundles/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/bundles/${id}/status`, null, { params: { status } })
  },
  remove(id) {
    return api.delete(`/therapy/bundles/${id}`)
  },
  fetchPurchases(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/bundle-purchases?${query.toString()}`)
  },
  fetchPurchaseDetail(id) {
    return api.get(`/therapy/bundle-purchases/${id}`)
  },
  confirmPurchasePayment(id) {
    return api.patch(`/therapy/bundle-purchases/${id}/confirm-payment`)
  },
  cancelPurchase(id) {
    return api.patch(`/therapy/bundle-purchases/${id}/cancel`)
  }
}
